import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { TypeBxTextOverImageHeroFields } from 'contentful-types'

import BXTextOverImageHero from './BXTextOverImageHero'

const ContentfulBXTextOverImageHero = withContentful<TypeBxTextOverImageHeroFields>(BXTextOverImageHero)

export default ContentfulBXTextOverImageHero
